export { default as emptyActionImage } from "../../assets/images/empty-screen/empty_action.png";
export { default as emptyCommentImage } from "../../assets/images/empty-screen/empty_comment.png";
export { default as emptyFlowImage } from "../../assets/images/empty-screen/empty_flow.png";
export { default as emptyHistoryImage } from "../../assets/images/empty-screen/empty_history.png";
export { default as emptyRecordImage } from "../../assets/images/empty-screen/empty_record.png";
export { default as emptyStateImage } from "../../assets/images/empty-screen/empty_state.png";
export { default as emptyUserImage } from "../../assets/images/empty-screen/empty_user.png";
export { default as emptyViewsImage } from "../../assets/images/empty-screen/empty_views.png";
